
import Vue, { PropType } from 'vue'
import SaIcon from '~/components/_general/SaIcon.vue'
import { SaIconsType } from '~/assets/ts/types/icons'

export default Vue.extend({
  name: 'SiteFancyInput',
  components: {
    SaIcon,
  },
  props: {
    disabled: {
      type: Boolean,
    },
    icon: {
      type: String as PropType<SaIconsType>,
      default: undefined,
    },
  },
  data() {
    return {
      focus: false,
    }
  },
  watch: {
    focus() {
      this.$emit('focus', this.focus)
    },
  },
  methods: {
    focusInput() {
      if (!this.disabled) return
      // Search for an input element within the component's root element
      const input = this.$el.querySelector('input')
      if (input) {
        input.focus()
      }
    },
    focusIn(event: FocusEvent) {
      this.focus = true
      this.$emit('focusin', event)
    },
    focusOut(event: FocusEvent) {
      this.focus = false
      this.$emit('focusout', event)
    },
  },
})
